import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    profile: {
      user: Object.assign({
        clientId: null,
        userId: null,
        userName: null,
        email: null,
        roles: [],
        securityLevel: null,
        approvalStatus: null
      }, window.userProfile || {}),

      locations: Object.assign({
        userLocations: [],
        locationRequests: [],
        activeLocationId: null
      }, window.userLocations || {})
    }
  },
  getters: {
    get: state => state.profile,
    getUserId: state => state.profile.user.userId,
    getLocations: state => state.profile.locations,
    getActiveLocationId: state => state.profile.locations.activeLocationId || (state.profile.locations.userLocations[0] || {}).locationId || null
  },
  mutations: {
    setLocations (state, locations = []) {
      const userLocations = locations.filter(l => l.isAccepted === true)
      const locationRequests = locations.filter(l => l.isAccepted === false)

      Vue.set(state.profile.locations, 'userLocations', userLocations)
      Vue.set(state.profile.locations, 'locationRequests', locationRequests)
    },
    setActiveLocationId (state, locationId = null) {
      Vue.set(state.profile.locations, 'activeLocationId', locationId)
    }
  },
  actions: {
    /**
     * Switches active location like the header location flyout: full navigation with ?setCurrentLocation=.
     * Layout ScriptProfile persists the location, then runs OpenID Connect so Identity re-issues tokens
     * (selected-location-id in the Bearer token for Service Platform APIs).
     */
    setActiveLocationId (context, locationId = null) {
      if (!locationId) {
        return Promise.resolve()
      }
      const url = new URL(window.location.href)
      url.searchParams.set('setCurrentLocation', locationId)
      window.location.assign(url.toString())
      return new Promise(() => {})
    }
  }
}
